﻿import {Grid, GridOwnProps} from "@mui/material";
import React from "react";

type TabsContainerProps = GridOwnProps & {
  GridItem?: typeof Grid;
}

/**
 * Grid container used to space mui's Tab contents properly
 * @param children passthrough children to inner mui Grid
 * @param rest passthrough props to the inner grid
 * @constructor
 */
const TabsSubContainer = ({children, ...rest}: GridOwnProps) => {
  return <Grid item xs {...rest}>
    {children}
  </Grid>
}

/**
 * Container for setting up the proper spacing for using Tabs
 * @param children children passed down to the inner GridItem
 * @param GridItem Slot for inner mui Grid item, adjustable by supplying ur own Grid component. defaults to TabsSubContainer
 * @param rest rest of the props passed through to the outer Grid
 * @constructor
 * @example
 *   <TabContextContainer>
 *     <TabContext value={currentTab + ''}>
 *       <TabsContainer>
 *         <Tabs>
 *           ...
 *         </Tabs>
 *       </TabsContainer>
 *     </TabContext>
 *   </TabContextContainer>
 */
export const TabsContainer = ({children, GridItem = TabsSubContainer, ...rest}: TabsContainerProps) => {
  return <Grid container justifyContent={'space-between'} alignItems={'center'} {...rest}>
    <GridItem>
      {children}
    </GridItem>
  </Grid>
}
